import template from './template.html'

angular.module('contabilidad.reportenominasmovimientos')
  .component('contabilidadReportenominasmovimientosClientes', {
    controller: ContabilidadReportenominasmovimientosClientesComponent,
    template,
    bindings: {
      empresaId: '<',
      data: '<',
      onChange: '&',
    },
  })

function ContabilidadReportenominasmovimientosClientesComponent ($filter, ContabilidadReportenominasmovimientosEmpresasClientes) {
  var $ctrl = this
  $ctrl.$onChanges = $onChanges
  $ctrl.aceptar = aceptar
  $ctrl.obtenerCatalogo = obtenerCatalogo
  $ctrl.totalizar = totalizar
  $ctrl.seleccionar = seleccionar
  $ctrl.validar = validar

  $ctrl.editando = false
  $ctrl.total = null
  $ctrl.clientes = null
  $ctrl.seleccionados = []
  $ctrl.orderBy = $filter('orderBy')

  function $onChanges (changes) {
    if (changes.data) {
      if (!Array.isArray($ctrl.data)) {
        $ctrl.data = []
      }

      $ctrl.seleccionar()
    }

    if (changes.empresaId) {
      $ctrl.obtenerCatalogo()
      $ctrl.onChange({$event: {detail: $ctrl.data}})
    }
  }

  function aceptar () {
    $ctrl.editando = false
    var detail = $ctrl.clientes ? ($ctrl.clientes.length === $ctrl.seleccionados.length) ? [] : [].concat($ctrl.seleccionados) : null
    $ctrl.onChange({$event: {detail: detail}})
  }

  function obtenerCatalogo () {
    $ctrl.clientes = null

    return $ctrl.promise = ContabilidadReportenominasmovimientosEmpresasClientes.get($ctrl.empresaId)
      .then(function (resolve) {
        $ctrl.clientes = $ctrl.orderBy(resolve.data, ['descripcion'])
        $ctrl.seleccionar()
      })
  }

  function seleccionar () {
    if (!$ctrl.clientes) return

    if ($ctrl.data.length) {
      $ctrl.seleccionados = [].concat($ctrl.data)
      $ctrl.validar()
    } else {
      $ctrl.seleccionados = $ctrl.clientes.map(function (item) {
        return item.id
      })
    }

    $ctrl.totalizar()
  }

  function totalizar () {
    if ($ctrl.clientes && $ctrl.clientes.length) {
      $ctrl.total = $ctrl.data.length
        ? $ctrl.clientes.reduce(function (total, cliente) {
          if ($ctrl.seleccionados.includes(cliente.id)) total.push(cliente.descripcion)
          return total
        }, []).join(', ')
        : 'Todos los clientes'
    } else {
      $ctrl.total = ''
    }
  }

  function validar () {
    if ($ctrl.clientes) {
      var clientes = $ctrl.clientes.map(function (item) {
        return item.id
      })

      $ctrl.seleccionados = $ctrl.seleccionados.filter(function (id) {
        return clientes.includes(id)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/reportenominasmovimientos/components/clientes/component.js